import React, { FC, useContext } from 'react';
import SecondaryButton from '../SecondaryButton';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { ActionType } from 'utils/action.type.enum';

const Container: FC<{
  children?: React.ReactNode;
  title: string;
  OnBackClicked?: () => void;
  subTitle?: string;
  btnTitle?: string;
  btn1Clicked?:()=>void
  btn1Title?:string

  module_code?: string;
  actionType?: ActionType
}> = ({ children, title, btnTitle, subTitle = null, OnBackClicked,
  btn1Clicked,
  btn1Title,
  actionType,
  module_code,
}) => {

    const { permission } = useContext(ConfigurationContext);

    const modulePermission = permission?.find(
      (item: any) => item.module_code === module_code
    );


  const hasPermission =(actionType &&module_code)?  modulePermission
    ? modulePermission[actionType]
    : false:true
    return (
      <div className="main-content ">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card" style={{ borderRadius: 12 }}>
                  <div className="card-header " style={{ borderRadius: 12 }}>
                    <div className="d-flex justify-content-between ">
                      <h4 className="card-title mb-1 ">{title}</h4>
                  <div className="d-flex gap-3">
  {OnBackClicked && hasPermission && (
    <SecondaryButton title={btnTitle || 'Go Back'} onClick={OnBackClicked} />
  )}

  {btn1Clicked && btn1Title && (
    <SecondaryButton title={btn1Title || 'Go Back'} onClick={btn1Clicked} />
  )}
</div>
                    </div>
                    <div>
                      {subTitle != null && (
                        <h5 className="card-title mb-0" style={{ fontSize: '12px' }}>
                          {subTitle}
                        </h5>
                      )}
                    </div>
                  </div>

                  <div className="card-body" style={{ borderRadius: 12 }}>
                    <div id="customerList">{children}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default Container;
